import { render, staticRenderFns } from "./detailTemp.vue?vue&type=template&id=537a9122&scoped=true&"
import script from "./detailTemp.vue?vue&type=script&lang=js&"
export * from "./detailTemp.vue?vue&type=script&lang=js&"
import style0 from "./detailTemp.vue?vue&type=style&index=0&id=537a9122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a9122",
  null
  
)

export default component.exports